import { configureStore } from "@reduxjs/toolkit";
import { apiBase } from "../features/api/apiBase";
import { apiAlarms } from "../features/api/apiAlarms";
import { apiNotifications } from "../features/api/api-notifications";

import alarmsReducer from "../features/Alarms/alarmsSlice";
import reportReducer from "../Components/REPORTS/reportsSlice";
import alarmRulesReducer from "../features/AlarmRules/alarmRulesSlice";
import authenticationReducer from "../features/authentication/auth-slice";
import sidebarReducer from "../Components/NewSidebar/sidebarSlice";
import { scheduledReportsApi } from "../features/api/scheduled-reports/scheduled-report.service";
import { userApi } from "../features/api/user/user.service";
import { deviceTypeApi } from "../features/api/device-types/device-type.service";
import { customerApi } from "../features/api/customer/customer.service";
import { deviceKeysApi } from "../features/api/device-keys/device-keys.service";
import { deviceApi } from "../features/api/device/device.service";
import { systemConfigurationApi } from "../features/api/system/system.service";
import { notificationConfigurationApi } from "../features/api/notification/notification.service";
import { kavachEventLogsApi } from "../Components/Kavach-dashboard/api/kavachEventLogs.service";

export default configureStore({
  reducer: {
    [apiBase.reducerPath]: apiBase.reducer,
    [apiAlarms.reducerPath]: apiAlarms.reducer,
    [apiNotifications.reducerPath]: apiNotifications.reducer,
    [scheduledReportsApi.reducerPath]: scheduledReportsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [deviceTypeApi.reducerPath]: deviceTypeApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [deviceKeysApi.reducerPath]: deviceKeysApi.reducer,
    [deviceApi.reducerPath]: deviceApi.reducer,
    [systemConfigurationApi.reducerPath]: systemConfigurationApi.reducer,
    [notificationConfigurationApi.reducerPath]: notificationConfigurationApi.reducer,
    [kavachEventLogsApi.reducerPath]: kavachEventLogsApi.reducer,
    alarm: alarmsReducer,
    reporting: reportReducer,
    alarm_rules: alarmRulesReducer,
    authentication: authenticationReducer,
    sidebar: sidebarReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      apiBase.middleware,
      apiAlarms.middleware,
      apiNotifications.middleware,
      scheduledReportsApi.middleware,
      userApi.middleware,
      deviceTypeApi.middleware,
      customerApi.middleware,
      deviceKeysApi.middleware,
      deviceApi.middleware,
      systemConfigurationApi.middleware,
      notificationConfigurationApi.middleware,
      kavachEventLogsApi.middleware,
    ]),
});
